module.exports = __webpack_public_path__ + "img/83.e53b58e0.jpg";